import Icon, { IconType } from 'components/Icon';
import * as S from './styles';

export interface ViewToggleOption {
	value: string;
	icon: IconType;
	title: string;
}

interface ViewToggleProps {
	options: ViewToggleOption[];
	value: string;
	onChange: (value: string) => void;
}

const ViewToggle = ({ options, value, onChange }: ViewToggleProps) => {
	return (
		<S.Base>
			{options.map((option) => (
				<S.Button
					key={option.value}
					type="button"
					$selected={value === option.value}
					onClick={() => onChange(option.value)}
					title={option.title}
				>
					<Icon type={option.icon} width={16} height={16} />
				</S.Button>
			))}
		</S.Base>
	);
};

export default ViewToggle;
